import React, { Component } from 'react'
import { Form, Input } from 'antd';
import {classificationActions} from 'actions'

class SpeciesForm extends Component {
    constructor(){
        super();
        this.handleSubmit = this.handleSubmit.bind(this);
        classificationActions.fetch();
        this.handleDestroySpecies = this.handleDestroySpecies.bind(this)
    }
    async handleSubmit(values){
        if(this.classification.id){
            await classificationActions.update({
                id: this.classification.id,
                ...values
            })
            this.props.onClose()
        }else{
            const classification = await classificationActions.create({
                ...values
            })
            this.props.onSetCurrentSpecies(classification.id)
            this.props.onClose()
        }
    }

    async handleDestroySpecies(e){
        e.preventDefault()
        
        await classificationActions.destroy(this.classification.id)
        this.props.onSetCurrentSpecies('')
        this.props.onClose()
    }
    get classification(){
        return {
            ...(this.props.classification || {})
        }
    }

    get form() {
        return Object(this.props.formRef).current
    }

    render(){
        return (
            <div> 
                <Form.Item 
                    label="Name"
                    name="name"
                    rules={[{ required: true, message: 'Please input Species name!' }]}
                >
                    <Input placeholder="Name of Species" />
                </Form.Item>
                <Form.Item 
                    label="Description"
                    name="description"
                >
                    <Input.TextArea placeholder="Description" />
                </Form.Item>
            </div>
        )
    }
}

export default SpeciesForm